import { DatePeriodDeserializer } from "./DatePeriodDeserializer";
import * as z from "zod";

export const SpecialOpeningHoursDeserializer = z.object({
  id: z.string().uuid(),
  period: DatePeriodDeserializer,
});
export const ManySpecialOpeningHoursDeserializer = z.array(
  SpecialOpeningHoursDeserializer
);
